<automata-automation-replacement-chips
  [label]="label"
  [dataService]="fieldOptionsService"
  [formControl]="textInputControl"
  [isRequired]="true"
  [multiple]="true"
  [supportDataPassing]="showVariableItemMenu"
  [supportedDataTypes]="supportedDataTypes"
  [id]="id"
  [extraData]="{ fieldId: config?.fieldId, objectType: config?.crmObjectType }"
  [allowCustomValues]="true"
></automata-automation-replacement-chips>
